import { toast } from "sonner";
import { createContext, useContext, useEffect, useState } from "react";
import { useI18n } from "./i18n";

const CartCtx = createContext(null);
export function CartProvider({ children }) {
    const { t } = useI18n();

    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(
                localStorage.getItem("sp_cart") || "[]"
            );
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(
            "sp_cart",
            JSON.stringify(items)
        );
    }, [items]);

    // ADD TO CART
    const add = (book, qty = 1) => {

        setItems((prev) => {

            // already exists check
            const found = prev.find(
                (x) => x.book_id === book.id
            );

                // যদি already থাকে তাহলে আর add হবে না
            if (found) {
                toast.error(t("already_in_cart"));
                return prev;
            }

            // নতুন item add
            return [
                ...prev,
                {
                    book_id: book.id,
                    title: book.title,
                    price:
                        book.discount_price ||
                        book.price,
                    quantity: qty,
                    cover_image:
                        book.cover_image,
                },
            ];
        });

        toast.success(t("added_to_cart"));
    };

    // REMOVE
    const remove = (id) => {
        setItems((prev) =>
            prev.filter(
                (x) => x.book_id !== id
            )
        );
    };

    // UPDATE
    const update = (id, qty) => {
        setItems((prev) =>
            prev.map((x) =>
                x.book_id === id
                    ? {
                          ...x,
                          quantity: Math.max(
                              1,
                              qty
                          ),
                      }
                    : x
            )
        );
    };

    // CLEAR
    const clear = () => setItems([]);

    // TOTAL
    const subtotal = items.reduce(
        (s, x) =>
            s + x.price * x.quantity,
        0
    );

    const count = items.reduce(
        (s, x) => s + x.quantity,
        0
    );

    return (
        <CartCtx.Provider
            value={{
                items,
                add,
                remove,
                update,
                clear,
                subtotal,
                count,
            }}
        >
            {children}
        </CartCtx.Provider>
    );
}

export function useCart() {
    return useContext(CartCtx);
}
